import { render, staticRenderFns } from "./OfficeInvoiceDetail.vue?vue&type=template&id=c1c529e0&scoped=true&"
import script from "./OfficeInvoiceDetail.vue?vue&type=script&lang=ts&"
export * from "./OfficeInvoiceDetail.vue?vue&type=script&lang=ts&"
import style0 from "./OfficeInvoiceDetail.vue?vue&type=style&index=0&id=c1c529e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c529e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow,VSpacer})
